import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/rules/logs/')({
  validateSearch: zodValidator(withDefaults(schema.RULES, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULES, app: APP_PATHS.DETECTIONS });
    context.validatePermissions({ isAllowed, preload });
  },
});
